<ng-container>
  <div class="organization-contact-information-container pr-0 pl-0">
    <span class="organization-contact-information-container__header">
      {{ "LABELS.ORGANIZATION_CONTACT_INFO" | translate | uppercase }}

      <span class="d-lg-none">
        <app-hint-tooltip-icon [hint]="'LABELS.ORGANIZATION_CONTACT_INFO_DESCRIPTION' | translate"></app-hint-tooltip-icon>
      </span>
    </span>
    <div class="d-flex" [formGroup]="formGroup">
      <div class="organization-contact-information-container-form pr-0 pl-0 col-12 col-lg-8">
        <div id="control-businessPhone">
          <!-- businessPhone -->
          <input-phone
            [fc]="contactInformationFormGroup.get('businessPhone')"
            [errors]="errors.businessPhone"
            [label]="'LABELS.ORGANIZATION_BUSINESS_PHONE'"
            [id]="'businessPhone'"
          ></input-phone>
        </div>
        <div id="control-businessEmail">
          <!-- businessEmail -->
          <app-control-wrapper [control]="contactInformationFormGroup.get('businessEmail')" [errors]="errors.businessEmail">
            <label for="businessEmail" control-label>
              {{ "LABELS.ORGANIZATION_BUSINESS_EMAIL" | translate }}
            </label>
            <input
              type="text"
              [formControl]="contactInformationFormGroup.get('businessEmail')"
              class="form-control"
              id="businessEmail"
              name="businessEmail"
              control-wrapper
            />
          </app-control-wrapper>
        </div>
      </div>
      <div class="d-none d-lg-block col-4">
        <div class="organization-contact-information-container-description">
          <span [innerHTML]="'LABELS.ORGANIZATION_CONTACT_INFO_DESCRIPTION' | translate"></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
